import { DOCUMENT, NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/module.d-CnjH8Dlt';
import { Component, HostListener, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, RouterOutlet } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoginapiService } from './components/auth/Pages/services/loginapi.service';
import { AuthConfigService } from './Configuration/auth-config.service';
import { ConfigurationService } from './Configuration/configuration.service';
import { BaseEntityResponse1 } from './Data/Models/Common/base-entity-model1';
import { SessionTimeOutModel } from './Data/Models/Common/session-time-out-model';
import { AuthService } from './services/auth.service';
import { SeesionTimeoutService } from './services/NewFolder/seesion-timeout.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgIf],
  templateUrl: './app.component.html'
})
export class AppComponent {
  @ViewChild('SessionPopup', { static: true }) SessionPopup: TemplateRef<any>
  sessionTimeOutPopup: boolean = false
  dialogRef: MatDialogRef<any> | null = null;
  title = 'Modernize Angular Admin Tempplate';
  currentUser = localStorage.getItem('currentUser');
  seconds: number = 0
  minutes: number = 5
  countdown: number = 0
  Reload_Interval: any;
  Reload_Timer: number = 0;
  _sub: Subscription;
  _sub1: Subscription;
  Hour: number = 0;
  Minutes: number = 20;
  constructor(private oauthService: OAuthService, private configService: ConfigurationService, private authService: AuthConfigService, private router: Router,
    private loginService: LoginapiService, public dialog: MatDialog, private idle: Idle, @Inject(DOCUMENT) private document: Document, private SessionTimeout: SeesionTimeoutService,
    public authServices: AuthService, private toastr: ToastrService) {

    this.configure();
    this.oauthService.tryLoginCodeFlow()
    this.oauthService.setupAutomaticSilentRefresh();
  }
  public get claims() {
    // //
    //let claims = this.oauthService.getIdentityClaims();
    let claims = this.oauthService.getIdentityClaims();
    return (claims || location.href.includes('credentials') || location.href.includes('forgot-password'));
   // return claims;
  }
  private configure() {

    this.oauthService.configure(this.authService.get());
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
    this.oauthService.loadDiscoveryDocument(this.configService.get().discoveryDocumentConfigUrl);
  }
  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:keydown', ['$event'])
  resetIdleTimer(): void {
    if (!this.dialogRef) {
      this.idle.watch()
    }
  }
  @HostListener('window:resize')
  onWindowResize() {
    const backdrop = this.document.querySelector('.cdk-overlay-backdrop');
    if (backdrop) {
      (backdrop as HTMLElement).click(); // Simulates a real outside click
    }
  }

  ChangeRoute() {

    var centralUserID = null
    if (this.currentUser) {
      const parsedUser = JSON.parse(this.currentUser);
      centralUserID = parsedUser.userID;

    }
    if (centralUserID) {
      this.loginService.GetCharityGrid(centralUserID).subscribe((data: any) => {
        localStorage.setItem("UserRecords", data);
        document.body.classList.add('loggedIn');
        if ((data == 0 && !this.router.url.includes(`/charity`)) && (localStorage.getItem("IsFromLandingPage") == 'true' && localStorage.getItem("IsFromLandingPage") != '')) {
          this.router.navigate(['/landingpage']);
          document.body.classList.add('norecords');
        }
        else {

        }
      })
    }

  }
  ngOnInit() {
    debugger;
    this.ChangeRoute()

    this._sub1 = this.loginService.sessionTimeOut$.subscribe((data: boolean) => {
      debugger
      if (data == true) {
        this.setUserSession()
        this.loginService.setSession(false)
      }
    })
  }

  setUserSession() {
    var UserId = null
    if (this.currentUser) {
      const parsedUser = JSON.parse(this.currentUser);
      UserId = parsedUser.userID;
    }
    if (UserId) {
      this.authServices.GetUserSession(UserId).subscribe((data: BaseEntityResponse1<SessionTimeOutModel>) => {
        if (data.status == 0) {
          if (data.entity != null && data.entity.length > 0) {
            this.Hour = data.entity[0].hours
            this.Minutes = data.entity[0].minutes
          }
          const totalSeconds = (this.Hour * 3600) + (this.Minutes * 60);
          this.idle.setIdle(1)
          this.idle.setTimeout(totalSeconds)
          this.setUpReloadInterval()
          this.idle.onTimeout.subscribe(() => {
            this.logout()
          })
          this.idle.onIdleStart.subscribe(() => {
            this.startIdleTimer()
          })
          this.idle.onTimeoutWarning.subscribe((countdown) => {
            this.countdown = countdown
            this.calculateTime(countdown)
            if (countdown <= 300) {
              if (!this.dialogRef) {
                this.OpenSessionTimeOut()
              }
            }
          })
          this.idle.onIdleEnd.subscribe(() => {
            // console.log('User is no longer idle.')
          })
        }
      },
        //  (error: HttpErrorResponse) => {
        //  this.toastr.error(error.statusText)
        //}
      )
    }

  }
  //setUserSession() {
  //  var UserId = this.currentUser;

  //  this.Hour = 0
  //  this.Minutes = 6
  //  debugger;
  //  const totalSeconds = (this.Hour * 3600) + (this.Minutes * 60);
  //  this.idle.setIdle(1)
  //  this.idle.setTimeout(totalSeconds)
  //  this.setUpReloadInterval()
  //  this.idle.onTimeout.subscribe(() => {
  //    this.logout()
  //  })
  //  this.idle.onIdleStart.subscribe(() => {
  //    this.startIdleTimer()
  //  })
  //  this.idle.onTimeoutWarning.subscribe((countdown) => {
  //    this.countdown = countdown
  //    this.calculateTime(countdown)
  //    if (countdown <= 300) {   // reqired 5 minutes
  //      if (!this.dialogRef) {
  //        this.OpenSessionTimeOut()
  //      }
  //    }
  //  })
  //  this.idle.onIdleEnd.subscribe(() => {
  //    // console.log('User is no longer idle.')
  //  })
  //  this.idle.watch();
  //}

  calculateTime(countdown: number): void {

    this.minutes = Math.floor(countdown / 60); // Calculate minutes
    this.seconds = countdown % 60; // Calculate seconds
  }


  stayLoggedIn() {
    this.CloseDialog()
    this.minutes = 5
    this.seconds = 0
    this.reset()
  }
  reset(): void {
    this.idle.watch();
  }
  LoginWithDifferentAccount() {
    this.logout();
  }

  logout() {
    this.CloseDialog();
    this.oauthService.logOut();
    this.authServices.logOut();
    this.idle.stop();
  }

  startIdleTimer(): void {
    this.CloseDialog();
    if (!this.idle.isRunning()) {
      this.idle.watch();
    }
  }

  CloseDialog() {
    if (this.dialogRef) {
      this.dialogRef.close()
      this.dialogRef = null
    }
  }

  setUpReloadInterval() {
    this.Reload_Interval = setInterval(() => {
      this.Reload_Timer = this.Reload_Timer + 1
      //console.log(this.Reload_Timer)
      if (this.loginService.Is_Stop_Interval) {
        this.loginService.Is_Stop_Interval = false;
        return
      }
      var Is_Upgrade_Renew = localStorage.getItem('Upgrade_Renew')
      if (Is_Upgrade_Renew == 'true') {
        localStorage.removeItem('Upgrade_Renew')
        this.Reload_Timer = 0;
        window.location.reload()
      }
    }, 4000)
  }

  OpenSessionTimeOut() {
    this.dialogRef = this.dialog.open(this.SessionPopup, { disableClose: true })
  }

  // Clean up on component destroy
  ngOnDestroy() {
    if (this.Reload_Interval) {
      clearInterval(this.Reload_Interval);
    }
    this.idle.stop();
    this.CloseDialog();
  }

}
